import { Component, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'close-btn',
	template: require('./close-btn.html')
})
export class CloseBtnComponent {
	@Output() action: EventEmitter<any> = new EventEmitter();

	constructor() {}

	onBtnClick() {
		this.action.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/components/common/buttons/close-btn/close-btn.ts